import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import PasswordInput from 'components/Inputs/PasswordInput'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import MainButton from 'components/Buttons/MainButton'
import passwordValidator from 'validators/passwordValidator'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  InfoText,
  WarningText,
  ErrorContainer
} from '../styles'

export default function ResetPasswordForm ({
  userData,
  userType = 'business',
  onSubmit: handleSubmitForm = () => null
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const { business, professional, token } = userData

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Formik
      validationSchema={passwordValidator}
      initialValues={{
        'password': '',
        'password_confirmation': ''
      }}
      onSubmit={async (values, { setSubmitting }) => {
        const { password } = values

        try {
          setSubmitting (true)

          const apiEndpoint = userType === 'company'
            ? `/companies/${business.id}`
            : !!business
              ? `/businesses/${business.id}`
              : `/businesses/${professional?.business_id}/professionals/${professional?.id}`

          await cutileiApi.put (apiEndpoint, { password }, requestConfig)

          setSubmitting (false)
          toggleOkDialog ()
        } catch (error) {
          setSubmitting (false)
          setErrorMessage (getApiErrorMessage (error))
          logApiError (error)
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onSubmit={handleSubmit}>
          <InfoText>
            Insira e confirme sua nova senha
          </InfoText>
          <FormField>
            <PasswordInput
              placeholder='Nova senha'
              value={values.password}
              onChange={handleChange ('password')}
              onBlur={handleBlur ('password')}
            />
            {touched.password && errors.password && (
              <WarningText>
                {errors.password}
              </WarningText>
            )}
            <PasswordStrengthBar password={values.password}/>
          </FormField>
          <FormField>
            <PasswordInput
              placeholder='Confirmar senha'
              value={values.password_confirmation}
              onChange={handleChange ('password_confirmation')}
              onBlur={handleBlur ('password_confirmation')}
            />
            {touched.password_confirmation && errors.password_confirmation && (
              <WarningText>
                {errors.password_confirmation}
              </WarningText>
            )}
          </FormField>
          {errorMessage && (
            <ErrorContainer>
              <p>{errorMessage}</p>
            </ErrorContainer>
          )}
          <AlertDialog
            visible={showOkDialog}
            title='Sucesso'
            message='Senha alterada!'
            confirmText='Ok'
            onConfirm={handleSubmitForm}
            onClose={handleSubmitForm}
          />
          <MainButton
            label='Redefinir senha'
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
            width={140}
          />
        </Form>
      )}
    </Formik>
  )
}
